import { Box, Typography, TextField, Select, MenuItem,  } from '@mui/material'
import { t } from 'i18next'
import React, { ChangeEvent, forwardRef } from 'react'
import FormStyling from '../../../../components/form/form-component'
import { theme } from '../../../../theme/maintheme'
import { APP_LANGUAGES } from '../../../../utils/constants'
import { CheckCircle, Error } from '@mui/icons-material'


type IProps = {
  handleChange : any
  orgRepresentative: any
  orgRepUsers: any
  handleFocusAndBlur: any
  fieldErrors: any
  fieldNames: any
  fieldRefs : any
  validate : any
  organizationSettings: any
  handlePaste: any
} 

export const Form = forwardRef((props: IProps, ref: React.Ref<any>) => {
  const {
    handleChange ,
    orgRepresentative, 
    handleFocusAndBlur,
    fieldErrors,
    fieldNames,
    fieldRefs,
    validate,
    organizationSettings,
    orgRepUsers,
    handlePaste
    
  } = props


  const errorIcon = (
    <Error
      sx={{
        display: "inline-block",
        marginRight: "4px",
        fontSize: 16,
        color: "var(--kyocera-red)",
      }}
    />
  );
  const checkIcon = (
    <CheckCircle
      sx={{
        display: "inline-block",
        fontSize: 16,
        marginRight: "4px"
      }}
    />
  );

  const getHelperText = (fieldName: string) => {
    let itemKey = "";

    switch (fieldName) {
      case fieldNames.DISPLAYNAME:
        itemKey = "settings_org_display";
        break;
      default:
        break;
    }
    const messageKey = validate[fieldName]?.message;


    if (!messageKey) {
      return "";
    }
    if (!fieldErrors[fieldName] || !validate[fieldName]) {
      return (
        <span style={{ color: "var(--kyocera-green)", display: "flex" }}>
          {checkIcon} {t(messageKey, { item: t(itemKey) })}
        </span>
      );
    }
    return (
      <>
        <span style={{ display: "flex", marginBottom:"12px" }}>
          {errorIcon} {t(messageKey, { item: t(itemKey) })}
        </span>
      </>
    );
  };


  return (
    <>
    {(
      <FormStyling>
      <Box
        sx={{
          border: "1px solid #000",
          borderRadius: "12px",
          padding: theme.spacing(3),
        }}
      >
        <Box>
          <Typography variant="body2" fontWeight={"bold"}>
            {t("settings_org_display")}
          </Typography>
          <TextField
            variant="outlined"
            inputProps={{
              maxLength: 220,
            }}
            id="txtOrganizationDisplayName"
            name="displayName"
            value={organizationSettings?.displayName}
            error={fieldErrors.displayName}
            helperText={getHelperText(fieldNames.DISPLAYNAME)}
            onChange={handleChange}
            onFocus={handleFocusAndBlur}
            onBlur={handleFocusAndBlur}
            inputRef={fieldRefs.displayName}
            onPaste={handlePaste}
            sx={{ margin: "8px 0  !important" }}
          />
        </Box>
  
        <Box>
          <Typography variant="body2" fontWeight={"bold"}>
            {t("settings_org_rep")}
          </Typography>
          <Select
            id="roles-select"
            name="representative"
            value={organizationSettings?.representative}
            onChange={handleChange}
            sx={{ fontSize: "14px", margin: "8px 0  !important" }}
          >
            {Object.entries(orgRepUsers).map((user: any) => (
              <MenuItem
                value={user[1].username}
                key={user[0]}
                sx={{ fontSize: "14px" }}
              >
                {user[1].username}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
      {/*
      <Box
        sx={{
          border: "1px solid #000",
          borderRadius: "12px",
          padding: theme.spacing(3),
          marginY: theme.spacing(4),
        }}
      >
        <Typography variant="body2" fontWeight={"bold"}>
          {t("settings_email_language")}
        </Typography>
  
        <Select
          id="language-select"
          name="locale"
          value={organizationSettings?.locale}
          onChange={handleChange}
          sx={{ margin: "8px 0  !important" }}
        >
          {Object.entries(APP_LANGUAGES).map((entry) => (
            <MenuItem
              value={entry[1].code}
              key={entry[1].code}
              sx={{ fontSize: "14px" }}
            >
              {entry[1].full}
            </MenuItem>
          ))}
        </Select>
      </Box>
      */}
    </FormStyling>
    )}
    </>
  )
})

export default Form